import React, { useEffect, useState } from "react";
import Icon from "components/AppIcon";
import { useNavigation } from "components/ui/NavigationStateManager";

const ProductInfo = ({ product, currentStore }) => {
  if (!product) return null;
  const sessionId = sessionStorage.getItem("vto_session_id");
  const { getDisplayStoreName, getDisplayProductName, langCode, languages } =
    useNavigation();
  const [loaderType, setLoaderType] = useState("existing");
  const [productName, setProductName] = useState("");
  const [appliedProductName, setAppliedProductName] = useState("");

  useEffect(() => {
    const name = getDisplayProductName(product) || "";
    // setProductName(name);
    setAppliedProductName(name);
  }, [product, langCode]);

  useEffect(() => {
    const timer = setTimeout(() => setAppliedProductName(productName), 400);
    return () => clearTimeout(timer);
  }, [productName]);

  useEffect(() => {
    if (window.VTOWidget?.init) {
      window.VTOWidget.init();
    }
  }, [langCode, loaderType, appliedProductName]);

  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center space-x-2 mb-2">
          <span className="text-sm text-text-secondary">
            {getDisplayStoreName()}
          </span>
        </div>
        <h1 className="text-heading-2 text-text-primary mb-2">
          {getDisplayProductName(product)}
        </h1>
        <p className="text-text-secondary text-sm">
          {(() => {
            try {
              const categories = JSON.parse(product?.aCategoryIdJson || "[]");
              const uniqueNames = [
                ...new Set(categories.map((cat) => cat.sCategoryName)),
              ];
              return uniqueNames.join(", ");
            } catch {
              return "";
            }
          })()}
        </p>
      </div>

      <div className="space-y-2">
        <div className="flex items-center space-x-3">
          <span className="text-heading-3 text-text-primary">
            {product?.dPrice ? <>₹{product.dPrice.toFixed(2)}</> : null}
          </span>
        </div>
      </div>

      <div>
        <p className="text-text-secondary">{product?.description}</p>
      </div>

      <div className="pt-4">
        <div className="mb-3">
          <label
            htmlFor="vto-product-name"
            className="block text-sm font-medium text-text-primary mb-1"
          >
            Product Name (sent to widget)
          </label>
          <input
            id="vto-product-name"
            type="text"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            placeholder="Enter product name"
            className="w-full px-3 py-2 text-sm rounded-lg border border-border bg-surface text-text-primary focus:outline-none focus:border-primary transition-smooth"
          />
        </div>
        <div className="flex items-center space-x-2 mb-3">
          <button
            type="button"
            onClick={() => setLoaderType("existing")}
            className={`flex-1 px-3 py-2 text-sm font-medium rounded-lg border transition-smooth ${
              loaderType === "existing"
                ? "bg-primary-50 border-primary text-primary"
                : "border-border text-text-secondary"
            }`}
          >
            Existing Loader
          </button>
          <button
            type="button"
            onClick={() => setLoaderType("new")}
            className={`flex-1 px-3 py-2 text-sm font-medium rounded-lg border transition-smooth ${
              loaderType === "new"
                ? "bg-primary-50 border-primary text-primary"
                : "border-border text-text-secondary"
            }`}
          >
            New Loader
          </button>
        </div>
        <button
          key={`${loaderType}-${appliedProductName}`}
          className="w-full btn-primary btn-lg flex items-center justify-center space-x-2"
          data-vto-button
          data-api-key={currentStore?.apiKey}
          data-session-id={sessionId}
          data-inventory-status="true"
          data-product-id={product?.sStoreVariantId || product?.sStoreProductId}
          data-cart-page="https://google.com"
          data-language-code={languages.length > 0 ? langCode : "en-US"}
          data-product-name={appliedProductName}
          data-loader={loaderType === "new" ? "true" : undefined}
        >
          <Icon name="Eye" size={20} />
          <span>Try On</span>
        </button>
        <p className="text-xs text-text-secondary text-center mt-2">
          Virtual Try-On available for this product
        </p>
      </div>

      <div className="p-4 bg-primary-50 rounded-lg border border-primary-200">
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Eye" size={16} className="text-primary" />
          </div>
          <div className="flex-1">
            <h4 className="text-sm font-medium text-primary mb-1">VTO Demo</h4>
            <p className="text-xs text-primary-700">
              This product supports Virtual Try On . Click the Try On button to
              validate the VTO integration.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
